export const ROUTES = {
  HOME: '/',
  TREND: '/',
  LIBRARY: '/library',
  ABOUT: '/about',
  SETTING: '/setting',
  BRAND: '/brand',
  BRAND_DETAIL: '/brand/:brandId',
  CONTENTS: '/content',
  CONTENT_DETAIL: '/content/:type/:id',
  PRODUCT_DETAIL: '/product/:productId',
  TERMS: '/terms',
  PRIVACY: '/privacy',
};

export default ROUTES;
